export const templateIds = {
	GDPR: 'gdpr',
	CCPA: 'ccpa',
	IAB_EU: 'iab_eu',
	MSPA: 'mspa',
	NOTICE: 'notice'
}

export const TEMPLATE_NAMES = {
	GDPR_TEXT: 'GDPR Compliant Text Template',
	GDPR_APPEARANCE: 'GDPR Compliant Appearance Template',
	CCPA_TEXT: 'CCPA (GPC) Compliant Text Template',
	CCPA_APPEARANCE: 'CCPA (GPC) Compliant Appearance Template',
	IAB_EU_TEXT: 'IAB Europe TCF 2.2 Compliant Text Template',
	IAB_EU_APPEARANCE: 'IAB Europe TCF 2.2 Compliant Appearance Template',
	MSPA_TEXT: 'IAB GPP MSPA Text Template',
	MSPA_APPEARANCE: 'IAB GPP MSPA Appearance Template',
	NOTICE_TEXT: 'Notice Only Text Template',
	NOTICE_APPEARANCE: 'Notice Only Appearance Template'
}

export const templateOptions = [
	{
		id: templateIds.GDPR,
		title: 'GDPR',
		description: 'Designed to collect and manage user consent in compliance with the EU’s General Data Protection Regulation (GDPR)',
		icon: 'mdi-shield-account'
	},
	{
		id: templateIds.CCPA,
		title: 'CCPA',
		description: 'Supports opt-out mechanisms required under the California Consumer Privacy Act (CCPA), including Do Not Sell/Share',
		icon: 'mdi-account-lock'
	},
	{
		id: templateIds.IAB_EU,
		title: 'IAB EU',
		description: 'Built to align with the IAB Europe Transparency and Consent Framework (TCF) v2.2 for standardized ad tech consent signaling',
		icon: 'mdi-web'
	},
	{
		id: templateIds.MSPA,
		title: 'MSPA',
		description: 'Configured to meet U.S. state privacy laws using the IAB’s Multi-State Privacy Agreement (MSPA) specifications',
		icon: 'mdi-scale-balance'
	},
	{
		id: templateIds.NOTICE,
		title: 'Notice',
		description: 'A minimal banner template that provides users with a notice of data practices without collecting consent',
		icon: 'mdi-information'
	},
	{
		id: null,
		title: 'Custom Configuration',
		description: 'Create a consent banner from scratch with control over all settings',
		icon: 'mdi-cog'
	}
]
